import React from 'react';
import { RoutesType } from '../../router.config';
import ToolBarButton from './tool-bar-button.component';

import { Box, Card, Typography } from '@mui/material';
import './scss/top-bar.style.scss';
import { observer } from 'mobx-react-lite';
import { TopBarState } from './top-bar-state';
import { MobxObjectsManager } from '../../page/mobx-objs/mobx-manager';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';


export const TopBarComponent = observer((props: Props) => {
    useTranslation();
    const { rightNode, className, hideActionButton, style } = props;
    const { title, subTitle } = MobxObjectsManager.get(TopBarState);

    return (
        <>
            <div className={`top-bar ${className || ''}`} style={style}>
                <div className='bg'>
                    <Card className='contentBox'>
                        <div className='top-left'>
                            <Box display='flex' alignItems='center'>
                                <Typography fontWeight={600} fontSize={'1.25rem'}>
                                    {i18n.t(title)}
                                </Typography>
                                <Typography sx={(theme) => { return { color: theme.palette.secondary.main, padding: '0 0.85rem' } }} >
                                    {i18n.t(subTitle)}
                                </Typography>
                            </Box>
                        </div>
                        {!hideActionButton &&
                            <div className='content'>
                                {
                                    rightNode
                                }
                                {
                                    rightNode ? <div className='line' /> : null
                                }
                                <ToolBarButton
                                    // notices={newMessages}
                                    showAvatar={props.showAvatar}
                                />
                            </div>}
                    </Card>
                </div>
            </div>
            {/* <LinearDeterminate /> */}
        </>
    )
})

// *************
// TYPE
// *************

type Props = {
    rightNode?: JSX.Element;
    className?: string;
    routes?: RoutesType[];
    clickRoute?: (route: string) => void;
    hideActionButton?: boolean;
    goBack?: boolean;
    // notices?: CallServiceFromServerEvent[];
    style?: React.CSSProperties;
    showAvatar?: boolean;
};
